import { useMutation } from 'react-query'
import useApi from '../../../hooks/use-api'
import useToasts from '../../../hooks/use-toasts'
import { useEnrollees } from './use-enrollees';

export const useCompulsion = ({
    courseId,
    user
}) => {
    const enrollmentCache = useEnrollees({ courseId });
    const toaster = useToasts();
    const { api, url, endpoints } = useApi();

    const onSuccess = (data, isRequired) => {
        toaster.success(`${user.firstName} ${user.lastName} ${isRequired ? 'cannot' : 'may'} drop this experience`);
        enrollmentCache.clear();
    }

    const [ updateCompulsion ] = useMutation(
        (isRequired) => api.post(url(endpoints.userCourseEnrollment, { userId: user.id, courseId }), { isRequired }),
        { onSuccess, onError: toaster.apiError }
    )

    const toggleCompulsion = updateCompulsion

    return {
        toggleCompulsion
    };
};
